import React, { useRef } from "react";
import Table from "../../../../common/tables/ActionTable";
import { CurrencyLabel } from "../../../../common/inputs";
import { ViewButton } from "../../../../common/containers/button";
import Utility from "../../../../supply-chain/utils/DateParser";
import authService from "../../../../../services/authService";
import externalApiService from "../../../../../services/externalApiService";

const InvoicesHistoryTable = ({
  entityGuid,
  selProduct,
  onShowAttachments,
}) => {
  const tableRef = useRef(null);
  const { ParseDateDMY } = Utility();

  const { constants } = authService.getCurrentUser();
  const { SUPPLYCHAIN, TRADEFINANCE, INVOICE } = constants.PRODUCTS;

  const PRODUCT_LABEL_MAP = {
    [SUPPLYCHAIN]: "Supplier",
    [TRADEFINANCE]: "Supplier",
    [INVOICE]: "Debtor",
  };

  const getContactLabel = (product) => PRODUCT_LABEL_MAP[product] || "Supplier";

  const columns = [
    {
      Header: "Inv No...",
      accessor: "inv_number",
      headerStyle: { textAlign: "left" },
      Cell: row => <span className="pull-left">{row.original.inv_number}</span>,
    },
    {
      Header: "Date",
      accessor: "trans_date",
      headerStyle: { textAlign: "left" },
      Cell: row => (
        <span className="pull-left">
          {row.original.trans_date ? ParseDateDMY(row.original.trans_date) : ""}
        </span>
      ),
    },
    {
      Header: "Due Date",
      accessor: "inv_due_date",
      headerStyle: { textAlign: "left" },
      Cell: row => (
        <span className="pull-left">
          {row.original.inv_due_date ? ParseDateDMY(row.original.inv_due_date) : ""}
        </span>
      ),
    },
    {
      Header: getContactLabel(selProduct),
      accessor: "supplier",
      headerStyle: { textAlign: "left" },
      Cell: row => <span className="pull-left">{row.original.supplier}</span>,
    },
    {
      Header: "Amount",
      accessor: "inv_amount",
      headerStyle: { textAlign: "left" },
      Cell: row => <span className="pull-left"><CurrencyLabel value={row.original.inv_amount} /></span>,
    },
    {
      Header: <i title="Attachment" className="fa fa-paperclip font-weight-bold"></i>,
      accessor: "action",
      
      sortable: false,
      filterable: false,
      Cell: row => (
        <button
          type="button"
          className="btn btn-sm p-0 text-secondary"
          onClick={() => onShowAttachments(row.original.transaction_reference)}
          aria-label={`View attachments for invoice ${row.original.inv_number}`}
        >
          <ViewButton />
        </button>
      ),
    },
  ];

  return (
    <>
        <Table
        ref={tableRef}
        service={externalApiService.GetBillHistory}
        cols={columns}
        uid="trans_guid"
        tableLeftPanel={null}
        reqParams={{
            entityId: entityGuid,
            productId: selProduct,
        }}
        />
    </>
  );
};

export default InvoicesHistoryTable;